import api from './axios';

export const getMigrations = (params) => api.get('/migrations', { params });
export const migrateEmployee = (data) => api.post('/migrations', data);
